import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { Platform, Pressable, Share } from 'react-native';

import { useThemePalette } from '@/config/theme';

type WebShareNavigator = Navigator & { share?: (data: { text?: string; title?: string }) => Promise<void> };

/** Share a text summary via the OS sheet (native) or the Web Share API (web). */
export function ShareButton({
  message,
  title,
  accessibilityLabel,
}: {
  message: string;
  title?: string;
  accessibilityLabel: string;
}) {
  const palette = useThemePalette();
  const onPress = async () => {
    try {
      const nav = typeof navigator !== 'undefined' ? (navigator as WebShareNavigator) : undefined;
      if (Platform.OS === 'web' && nav?.share) {
        await nav.share({ text: message, title });
      } else if (Platform.OS !== 'web') {
        await Share.share({ message });
      }
      // Web without the Share API: silently no-op (button stays available).
    } catch {
      // User dismissed the sheet, or sharing is unsupported - nothing to do.
    }
  };

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      onPress={onPress}
      hitSlop={8}
      className="h-9 w-9 items-center justify-center rounded-full bg-surface active:bg-surface-2"
    >
      <Ionicons name="share-social-outline" size={18} color={palette.soft} />
    </Pressable>
  );
}
